<template>
<div>
<v-navigation-drawer
  v-model="drawer"
      :permanent="inline || largeScreen" 
       :app="!largeScreen && !inline"
       right
      width="100%"
      :style="(largeScreen ? 'height:auto;' : ';') + 'margin-top:' + margin + 'px;'"
      floating 
      color="background" :class="{'rounded-lg' : largeScreen}"
    >
  <v-system-bar color="#ffffff" fixed v-if="platform=='ios'" height="33" app class="pa-0">
      </v-system-bar>
    <template v-slot:prepend >
    
      <template v-if="!inline && !host.stealth">
       <v-tabs fixed-tabs v-model="tabtype" slot="extension" v-if="largeScreen" height="60" background-color="transparent"
            >
              <v-tab value="deliver" v-if="allowDeliver"><v-icon class="mr-2">delivery_dining</v-icon>{{$t('Common.deliver')}}</v-tab>
              <v-tab value="takeaway"><v-icon class="mr-2">store</v-icon>{{$t('Common.takeaway')}}</v-tab>
              <v-tab value="deliver" v-if="!allowDeliver" :disabled="!allowDeliver">GEEN BEZORGING</v-tab>
            </v-tabs>
        <v-toolbar tile ref="headeritem" :class="{'mt-8' : platform=='ios'}"
            :dark="dark" v-else
              flat
          >
          <v-icon class="mr-2">shopping_cart</v-icon>
          <v-toolbar-title
              class="pl-0">
            {{title}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeMe"><v-icon>close</v-icon></v-btn>
            <template v-slot:extension >
              <v-tabs fixed-tabs v-model="tabtype" slot="extension"
            background-color="transparent">
              <v-tab value="deliver" v-if="allowDeliver"><v-icon class="mr-2">delivery_dining</v-icon>{{$t('Common.deliver')}}</v-tab>
              <v-tab value="takeaway"><v-icon class="mr-2">store</v-icon>{{$t('Common.takeaway')}}</v-tab>
              <v-tab value="deliver" v-if="!allowDeliver" :disabled="!allowDeliver">GEEN BEZORGING</v-tab>
            </v-tabs>
            </template>
          </v-toolbar>

      </template>
    </template>
   
  <v-card flat class="pt-3" v-bind="$attrs" outlined :class="{'mt-3' : !largeScreen, 'rounded-lg rounded-t-0' : largeScreen}" :tile="!largeScreen">
    
      <slot name="warning"></slot>
  <v-card-text class="px-0 pt-0 fill-height" :class="{'mt-3': !largeScreen}" >
    
     
    <v-expand-transition>
    <empty v-if="cartCount==0" icon="shopping_cart" text="Bestelling" description="Kies je favoriete gerechten en plaats je bestelling"></empty>
    </v-expand-transition>
    <v-list class="pa-0 px-3" >
     <v-data-iterator
      :items="cart"
      item-key="_id"
      :items-per-page="100"
      :single-expand="true"
      hide-default-footer
      no-data-text=" "
    >
      <template v-slot:default="{ items, isExpanded, expand }">
        
      
      <!--template v-for="(group,p) in items">
      <v-card-title v-if="group.name!='label' && groupedItems.length>1" :key="'s' + p" class="mt-4 primary--text font-weight-light">{{group.name}}</v-card-title>
      
      <div v-else class="mt-10" :key="'s' + p"></div>
      <v-list class="pa-0" :key="'l' + p">
      <v-divider></v-divider-->
        <template v-for="(product,p) in items">
          <v-divider :key="p + 'k'" v-if="p>0"></v-divider>
          <v-list-item :key="p" @click="editItem(product,p)">
            <v-list-item-content>
            <v-list-item-title>{{product.$name}}</v-list-item-title>
             <v-list-item-subtitle v-if="product.$subname">{{product.$subname}}</v-list-item-subtitle>
            <v-list-item-subtitle v-else-if="product.include">{{product.include.map(i=>i.name).join(', ')}}</v-list-item-subtitle>
            <v-list-item-subtitle v-else-if="product.description" class="font-weight-bold primary--text">{{product.description}}</v-list-item-subtitle>
            <v-list-item-subtitle v-if="product.$description" class="font-weight-bold primary--text mt-2" @click.stop="editDescription(product,p)">{{product.$description}} ...</v-list-item-subtitle>
            </v-list-item-content>
             <v-list-item-action class="caption red--text text-decoration-line-through" v-if="getPrice(product)<product.price">
                {{ product.$quantity*product.price | toCurrency }}
                <v-list-item-action-text></v-list-item-action-text>
                <!--v-list-item-action-text>+</v-list-item-action-text-->
              </v-list-item-action>
            <v-list-item-action class="text-body-1 align-content-start mt-2">
              {{getAmount(product) | toCurrency}}
            </v-list-item-action>
          </v-list-item>
          <div :key="p + 'ki'" class="d-flex pr-1 mb-2" style="margin-top:-10px">
            <!--v-btn text color="primary" class="caption" small v-if="product.$description" @click="editDescription(product,p)">Opmerking aanpassen</v-btn-->
            <v-btn text color="grey" class="caption mt-1" small v-if="!product.$description" @click="editDescription(product,p)">Opmerking toevoegen</v-btn>
            <v-spacer></v-spacer>
              <v-btn icon @click="removeCartItem(product)">
                <v-icon color="grey" v-if="product.$quantity == 1">delete</v-icon>
                <v-icon color="grey" v-else>mdi-minus</v-icon></v-btn>
                
                 <v-btn text class="text-h6 grey--text" style="min-width: 28px!important;width:28px;">{{product.$quantity}}</v-btn>
                <v-btn icon @click="addCartItem(product)"><v-icon color="grey">mdi-plus</v-icon></v-btn>
              </div>
          
        </template>
     
      <!--/template-->
    
      </template>
    </v-data-iterator>
    <slot name="extraitems"></slot>
    <template v-if="deliveryAmount>0">
         <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Bezorgkosten</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{deliveryAmount | toCurrency}}
              </v-list-item-action>
          </v-list-item>
            <v-divider></v-divider>
        </template>
      
      <template v-if="discountAmount>0">
               
         <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{discountNames}}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{-discountAmount | toCurrency}}
              </v-list-item-action>
          </v-list-item>
            <v-divider></v-divider>
        </template>
        <template v-if="transactionAmount>0 && checkout">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text-right grey--text"
                >iDEAL kosten</v-list-item-title
              >
            </v-list-item-content>
            <v-list-item-action>
              {{ transactionAmount | toCurrency }}
            </v-list-item-action>
          </v-list-item>
        </template>
        <slot name="extrainfo"></slot>
        </v-list>
        <!--center v-if="!largeScreen"><v-btn text color="grey" class="mt-5" @click="closeMe">Voeg meer items toe</v-btn></center-->
    </v-card-text>
    </v-card>
     <v-list-item v-if="checkOutAmount>0">
              <v-list-item-content>
                <slot name="totalinfo">
                <v-list-item-title class="text-right font-weight-light primary--text text-h6">TOTAAL</v-list-item-title>
                </slot>
              </v-list-item-content>
              <v-list-item-action class="text-right font-weight-bold primary--text text-h6">
                {{checkOutAmount | toCurrency}}
              </v-list-item-action>
          </v-list-item>
       
    
    <slot name="info"></slot>
   <v-btn color="grey" class="text-overline float-right" text @click="tabtype=1" v-if="deliver && takeawayAmount < checkOutAmount">Zelf halen voor {{takeawayAmount | toCurrency}}</v-btn>
    <v-btn color="grey" class="text-overline float-right" text @click="tabtype=0" v-else-if="allowCheckout && takeawayAmount!=deliverAmount">Laten bezorgen voor {{deliverAmount + deliveryCost | toCurrency}}</v-btn>
  <template v-slot:append>
   
  <v-card-actions flat class="justify-center" v-if="cartCount>0 && largeScreen">
   <slot name="buttons">
  <v-btn block depressed large class="flex-grow-1" :disabled="!allowCheckout || cartCount==0" v-if="checkout" :color="!dark ? 'primary' : null" @click="closeMe">{{$t('Common.done')}}<v-icon class="ml-2">navigate_next</v-icon></v-btn>
  <v-btn block large depressed class="flex-grow-1" v-else :disabled="!allowCheckout && !checkout || cartCount==0" :color="!dark ? 'primary': null" to="/checkout">{{$t('Common.checkout')}} <span>({{checkOutAmount | toCurrency}})</span><v-icon class="ml-2">navigate_next</v-icon></v-btn>
   </slot>
  </v-card-actions>
  
  </template>
   </v-navigation-drawer>
    <v-footer flat fixed class="justify-center" v-if="!checkout && cartCount>0 && drawer && !largeScreen" style="z-index:100" :height="platform=='ios' ? 90 : null">
   <slot name="buttons">
  <v-btn block large  :class="{'mb-5': platform=='ios'}" depressed class="flex-grow-1" :disabled="!allowCheckout && !checkout || cartCount==0" :color="!dark ? 'primary': null" to="/checkout">{{$t('Common.checkout')}} <span>({{checkOutAmount | toCurrency}})</span><v-icon class="ml-2">navigate_next</v-icon></v-btn>
   </slot>
  </v-footer>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CartFooter from '../components/CartFooter.vue'
import productItem from "@/modules/productItem";
import empty from '@/components/empty'
export default {
   mixins: [productItem],
  props: ['value', 'allowDeliver','allowCheckout','checkout', 'inline','scrollTop','donationAmount'],
  components: {
    CartFooter,
    empty
  },
  data () {
    return {
      window: 0,
      mini:true
    }
    },
  computed: {
    ...mapGetters([
      'cart','host','cartAmount',
      'discountlist',
'quantumDiscountAmount',
'percentDiscount','deliverAmount', 'takeawayAmount' , 'deliveryCost', 
'percentDiscountAmount', 'cartCount',
'discountAmount','discountNames','deliveryAmount','transactionAmount'
    ]),
    
    margin(){
      if (!this.largeScreen) return false
      let m = this.scrollTop + 47 - this.$config.page.bannerHeight
      if (m <0) return 0
      return m
    },
    amount (){
      return this.deliver ? this.deliverAmount : this.takeawayAmount
    },
    title() {
      return this.$t('Common.cart')
    },
    dark () {
      return this.$store.state.config.dark
    },
    checkOutAmount(){
      return this.cartAmount - this.discountAmount + this.deliveryAmount + (this.checkout ? (this.transactionAmount || 0) : 0) + (this.donationAmount || 0)
    },
    drawer: {
      get() {
       return this.value
      },
      set(value){
       this.$emit('input',value)
      }
    },
    tabtype: {
      get() {
        if (!this.allowDeliver) return 0
        return this.$store.state.config.type == 'deliver' ? 0 : 1
      },
      set(value){
        if (!this.allowDeliver) return this.setConfig({'type':'takeaway'})
        this.setConfig({'type': value == 0 ? 'deliver' : 'takeaway'})
      }
    },
    deliver(){
        return this.$store.state.config.type == "deliver"
    },
  },
  mounted() {
    
  },
  watch:{
    cart(value){
      //console.log(value, this.cartAmount)
      if (!value || value.length==0) return this.closeMe()
    },
    deliver(){
      this.updateCart()
      
    }
  },
  methods: {
    ...mapActions([
      'setConfig',
      'addCartItem',
      'removeCartItem',
      'setCartItem'
    ]),
    updateCart(){
      this.cart.map(p=>this.setProduct(p))
    },
    editItem(product,cartindex){
      product._cart = cartindex + 1
      this.$emit('edit',product)
    },
    editDescription(product,cartindex){
      product._cart = cartindex + 1
      this.$emit('comment',product)
    },
    orderThis(){

    },
    closeMe(){
      this.drawer=false
    },
    test(){
      console.log(this.cart)
    }
  }
}
</script>

